import SubjectAreaListResultModelBase from '../_generated/modelBases/subject-area-list-result-model-base';

export default class SubjectAreaListResultModel extends SubjectAreaListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
